import { TextField } from '@mui/material';
import { useState } from 'react';
import { CustomAttributeValue } from 'src/graphql/entities/custom-attributes/custom-attributes.types';
import { handleSingleLineKeys } from 'src/graphql/entities/custom-attributes/field-view-registry/components/single-line-input';
import { CustomAttributeEditProps } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';
import { useAutoFocusInput } from 'src/utils/hooks/use-autofocus-input';
import { useSettleCallbackOnce } from 'src/utils/hooks/use-settle-callback-once';
import { decodeNumberInput } from './utils';

export const NumberEditor = ({
  value,
  onChange,
  onSave,
  onCancel,
  disabled,
}: CustomAttributeEditProps) => {
  const initial = getKindLikeValueSafely(value, 'number');

  const [draft, setDraft] = useState(initial === null ? '' : String(initial));

  const inputRef = useAutoFocusInput<HTMLInputElement>();

  const commit = () => {
    const next: CustomAttributeValue = { kind: 'number', value: decodeNumberInput(draft) };
    onChange(next);
    onSave(next);
  };

  const callbacks = useSettleCallbackOnce({ onSave: commit, onCancel });

  return (
    <TextField
      inputRef={inputRef}
      value={draft}
      onChange={(event) => setDraft(event.target.value)}
      onBlur={callbacks.onSave}
      onKeyDown={handleSingleLineKeys(callbacks)}
      disabled={disabled}
      size="small"
      fullWidth
      type="number"
      autoComplete="off"
      inputProps={{ inputMode: 'decimal' }}
    />
  );
};
